// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"30483f19","239":"1298bb7e","732":"c2d44ec2"}[chunkId] + ".chunk.js";
};